import { createContext, useContext, type ReactNode } from 'react'

const ComposerReadOnlyContext = createContext(false)

/**
 * Marks the composer subtree as view-only. Set by ComposerShell when the active
 * creative is already published (live). The editing surfaces — chat input
 * (SideChat), the structured EditorModal, the desktop section-hover affordances
 * (SectionHoverWrapper), and the mobile action bar — read this to suppress edits.
 *
 * Keeps the composer consistent with the cards/PostModal stance: a live post is
 * view-only everywhere, never editable.
 */
export function ComposerReadOnlyProvider({
  readOnly,
  children,
}: {
  readOnly: boolean
  children: ReactNode
}) {
  return (
    <ComposerReadOnlyContext.Provider value={readOnly}>{children}</ComposerReadOnlyContext.Provider>
  )
}

export function useComposerReadOnly(): boolean {
  return useContext(ComposerReadOnlyContext)
}
